import { render, staticRenderFns } from "./TotalCalculateSub.vue?vue&type=template&id=79ca965c&scoped=true&"
import script from "./TotalCalculateSub.vue?vue&type=script&lang=js&"
export * from "./TotalCalculateSub.vue?vue&type=script&lang=js&"
import style0 from "./TotalCalculateSub.vue?vue&type=style&index=0&id=79ca965c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca965c",
  null
  
)

export default component.exports